module.exports = __webpack_public_path__ + "img/ideal.ba5e1562.png";